/**
 * Custom Couture / Archive editorial
 * - Click faded thumbs → swap large hero (Revice-style gallery)
 * - Scroll reveal on rows
 */
function upscaleShopifyImage(src, width) {
  try {
    const url = new URL(src, window.location.href);
    url.searchParams.set('width', String(width));
    return url.href;
  } catch {
    return src.replace(/([?&]width=)\d+/i, `$1${width}`);
  }
}

class ArchiveEditorial {
  constructor(root) {
    this.root = root;
    this.bindThumbs();
    this.bindReveal();
  }

  bindThumbs() {
    this.root.querySelectorAll('[data-archive-row]').forEach((row) => {
      const hero = row.querySelector('[data-archive-hero]');
      const thumbs = row.querySelectorAll('[data-archive-thumb]');
      if (!hero || !thumbs.length) return;

      const setActiveThumb = (thumb) => {
        thumbs.forEach((t) => {
          t.classList.remove('is-active');
          t.setAttribute('aria-current', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      };

      const showHero = (src, alt, activeThumb) => {
        if (!src) return;
        hero.src = src;
        if (alt != null && alt !== '') hero.alt = alt;
        hero.removeAttribute('srcset');
        hero.removeAttribute('sizes');
        setActiveThumb(activeThumb);
      };

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const thumbPhoto = thumb.querySelector('.archive-editorial__thumb-img');
          const fullSrc =
            thumb.getAttribute('data-archive-thumb-src') ||
            (thumbPhoto ? upscaleShopifyImage(thumbPhoto.currentSrc || thumbPhoto.src, 1200) : '');
          const alt = thumbPhoto ? thumbPhoto.alt || '' : '';
          showHero(fullSrc, alt, thumb);
        });
      });
    });
  }

  bindReveal() {
    const rows = this.root.querySelectorAll('[data-archive-row]');
    if (!rows.length || !('IntersectionObserver' in window)) {
      rows.forEach((row) => row.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    rows.forEach((row) => observer.observe(row));
  }
}

document.querySelectorAll('[data-archive-editorial]').forEach((root) => {
  new ArchiveEditorial(root);
});
